import { render, staticRenderFns } from "./select.vue?vue&type=template&id=1e2995bc"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports